/**
 * Impl dos use cases de DocumentoTipo (CRUD admin acadadmin).
 *
 * @since G.5.1
 */
import type { DocumentoTipo, DocumentoTipoCommand } from '@/domain/model/Documento';
import type { Page } from '@/domain/model/Page';
import type {
  DocumentoTipoGateway, ListDocumentoTiposAdminParams,
} from '@/application/port/out/DocumentoTipoGateway';
import type {
  ListDocumentoTiposAdminUseCase, GetDocumentoTipoUseCase,
  CreateDocumentoTipoUseCase, UpdateDocumentoTipoUseCase, DeactivateDocumentoTipoUseCase,
} from '@/application/port/in/DocumentoTipoUseCase';

export class ListDocumentoTiposAdmin implements ListDocumentoTiposAdminUseCase {
  constructor(private readonly g: DocumentoTipoGateway) {}
  execute(params: ListDocumentoTiposAdminParams): Promise<Page<DocumentoTipo>> { return this.g.list(params); }
}
export class GetDocumentoTipo implements GetDocumentoTipoUseCase {
  constructor(private readonly g: DocumentoTipoGateway) {}
  execute(id: string): Promise<DocumentoTipo> { return this.g.get(id); }
}
export class CreateDocumentoTipo implements CreateDocumentoTipoUseCase {
  constructor(private readonly g: DocumentoTipoGateway) {}
  execute(cmd: DocumentoTipoCommand): Promise<DocumentoTipo> { return this.g.create(cmd); }
}
export class UpdateDocumentoTipo implements UpdateDocumentoTipoUseCase {
  constructor(private readonly g: DocumentoTipoGateway) {}
  execute(id: string, cmd: DocumentoTipoCommand): Promise<DocumentoTipo> { return this.g.update(id, cmd); }
}
export class DeactivateDocumentoTipo implements DeactivateDocumentoTipoUseCase {
  constructor(private readonly g: DocumentoTipoGateway) {}
  execute(id: string): Promise<void> { return this.g.deactivate(id); }
}
